<script>
import SmsIndex from "./index.vue";
  export default {
    extends: SmsIndex,

    data() {
      return {
        items: [
          {key: 1, value: '[[contact_first_name]]'},
          {key: 2, value: '[[contact_last_name]]'},
          {key: 3, value: '[[contact_full_name]]'},
          {key: 4, value: '[[contact_email]]'},
          {key: 5, value: '[[contact_phone_number]]'},
          {key: 6, value: '[[representative_name]]'},
          {key: 7, value: '[[representative_email]]'},
          {key: 8, value: '[[brand_title]]'},
        ],
      };
    },
  }
</script>

